require('@material/dialog/mdc-dialog.scss');
require('@material/form-field/mdc-form-field.scss');
require('@material/checkbox/mdc-checkbox.scss');

require('@os/mdc/dialog.scss');
require('@os/mdc/text-field.scss');
require('@os/mdc/checkbox.scss');
require('@os/mdc/floating-label.scss');

require('../../sass/plain-overlay/plain-overlay.scss');
require('../../sass/enroll/enroll.scss');
require('../../sass/single-survey/single-survey.scss');
require('../../sass/certificate-review/certificate-review.scss');

define(['jquery', '@material/dialog', '@material/textfield',
	'@material/checkbox', '@material/radio', '@os/form-data',
	'parsleyjs', 'js-cookie', 'moment', 'i18next'
], function ($, mdcDialog, mdcTextField, mdcCheckbox,
	mdcRadio, formData, parsley, jsCookie, moment, i18next) {

	jQuery = $;
	require('jquery-plainoverlay');
	var templateModalSingleSurvey = require('../../view/single-survey.hbs');

	return {
		init: function (survey_id, company_id) {
			showLoadingOverlay();

			var promises = [];
			promises.push(new Promise(function (resolve, reject) {
				$.ajax({
					type: 'POST',
					url: '/api/certificate/single/survey',
					data: {
						survey_id: survey_id,
						company_id: company_id
					},
					dataType: 'json'
				}).done(function (data) {
					resolve(data);
				}).fail(function (xhr, error) {
					reject(error);
				});
			}));

			Promise.all(promises).then(function (result) {
				let data = result[0];
				if (data && data['survey_id'] > 0) {
					$("body").append(templateModalSingleSurvey(result[0]));
					$('.single-survey .date-label').html(moment.utc($('.single-survey .date-label').html()).format('MMMM YYYY'));
					$('.single-survey .moment_date').html(moment.utc($('.single-survey .moment_date').html()).fromNow());$(".trimmed-full-text").hide();
					$('.single-survey .trimmed-full-text').hide();
					$('.single-survey .trimmed-read-more').html(i18next.t('certificate-review:read_more'));
					dialog = new mdcDialog.MDCDialog(document.querySelector('#modalSingleSurvey'));
					dialog.show();
				}
				hideLoadingOverlay();
			}, function (reason) {
				// error occurred
			});
		

			function showLoadingOverlay(target) {
				if (typeof target === 'undefined') {
					target = 'body';
				}
				$(target).plainOverlay('show', {
					progress: function () {
						return $('<div class="plain-overlay__icon"></div>');
					}
				});
			}

			function hideLoadingOverlay(target) {
				if (typeof target === 'undefined') {
					target = 'body';
				}
				$(target).plainOverlay('hide');
			}
		}
	};
});